import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { StaticHtmlTemplate } from "./staticHtmlTemplate";
import { StaticHtmlTemplateC } from "./staticHtmlTemplateC";
import { StaticHtmlTemplateD } from "./staticHtmlTemplateD";
import { StaticHtmlTemplateE } from "./staticHtmlTemplateE";
import { getPaperConfig } from "./paperSize";

const NewFrontCard = React.forwardRef(({ visitingOneFrontPrintRef }, ref) => {
  const { printingData, card_size, paper_size } = useSelector(
    (state) => state.printing,
  );
  const paper = getPaperConfig(paper_size);

  const splitPrintingData = (data) => {
    const chunkSize = paper.chunkSize;
    const chunks = [];
    for (let i = 0; i < data?.length; i += chunkSize) {
      chunks?.push(data?.slice(i, i + chunkSize));
    }
    return chunks;
  };

  const chunks = splitPrintingData(printingData);

  return (
    <div ref={visitingOneFrontPrintRef}>
      {chunks?.map((chunk, chunkIndex) => (
        <div
          key={chunkIndex}
          style={{
            // Trim only the LAST page by max(2px, lastPageTrimPerPage * page count) — a margin
            // that grows with the number of pages (html2canvas's sub-pixel height excess
            // accumulates per page) with a 2px floor for small jobs, so the total clears
            // html2pdf's page-count boundary at any size. Other pages stay paper.pageHeight (no
            // drift). No lastPageTrimPerPage configured => no trim.
            height: `${
              chunkIndex === chunks.length - 1
                ? paper.pageHeight -
                  (paper.lastPageTrimPerPage
                    ? Math.max(2, paper.lastPageTrimPerPage * chunks.length)
                    : 0)
                : paper.pageHeight
            }px`,
          }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              columnGap: paper.front.columnGap,
              rowGap: paper.front.rowGap,
              paddingLeft: paper.front.paddingLeft,
              paddingRight: paper.front.paddingRight,
              fontFamily: "'Graphik',san-serif",
              width: paper.containerWidth,
              fontSize: 8,
              // Left-aligned horizontally. A5 centers vertically (verticalCenter);
              // A3/A4 stay top-aligned via paddingTop.
              ...(paper.verticalCenter
                ? { height: "100%", alignContent: "center" }
                : { paddingTop: paper.front.paddingTop }),
            }}
          >
            <title>DHC Card</title>
            {chunk?.map((value, mainIndex) => {
              let template;

              if (value?.center_stone_side_stone) {
                template = <StaticHtmlTemplateC value={value} sideMargin={paper.cardSideMargin} topMargin={paper.cardTopMargin} />;
              } else if (parseInt(value?.qr_and_image_format) === 3) {
                template = <StaticHtmlTemplateD value={value} sideMargin={paper.cardSideMargin} topMargin={paper.cardTopMargin} />;
              } else {
                card_size === 1
                  ? (template = <StaticHtmlTemplate value={value} sideMargin={paper.cardSideMargin} topMargin={paper.cardTopMargin} />)
                  : (template = <StaticHtmlTemplateE value={value} sideMargin={paper.cardSideMargin} topMargin={paper.cardTopMargin} />);
              }

              return (
                <div className="item-class" key={mainIndex}>
                  {template}
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
});

export default NewFrontCard;
